/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { UpdateManualEntryMutationRequest, UpdateManualEntryMutationResponse, UpdateManualEntryPathParams, UpdateManualEntry400, UpdateManualEntry401, UpdateManualEntry403, UpdateManualEntry404, UpdateManualEntry409, UpdateManualEntry500 } from "../../types/financialHubController/UpdateManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getUpdateManualEntryUrl(organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"]) {
  const res = { method: 'PUT', url: `/api/organizations/${organizationId}/financial/transactions/${transactionId}` as const }
  return res
}

/**
 * @summary Update a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export async function updateManualEntry(organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest, config: Partial<RequestConfig<UpdateManualEntryMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, UpdateManualEntryMutationRequest>({ method : "PUT", url : getUpdateManualEntryUrl(organizationId, transactionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}